export interface FloatingChatSize {
  width: number;
  height: number;
}

/** 右下固定の小窓なので、つかめるのは左端・上端・左上角だけ。 */
export type FloatingChatResizeEdge = "left" | "top" | "top-left";

export const DEFAULT_FLOATING_CHAT_SIZE: FloatingChatSize = {
  width: 450,
  height: 600,
};
export const MIN_FLOATING_CHAT_SIZE: FloatingChatSize = {
  width: 320,
  height: 360,
};
/** 小窓と画面端の余白（上下左右）。 */
export const FLOATING_CHAT_MARGIN = 24;

interface ResizeFloatingChatParams {
  start: FloatingChatSize;
  edge: FloatingChatResizeEdge;
  /** ドラッグ開始位置からのポインタ移動量（右・下が正）。 */
  deltaX: number;
  deltaY: number;
  viewport: FloatingChatSize;
}

const clamp = (value: number, min: number, max: number): number =>
  Math.max(min, Math.min(Math.max(min, max), value));

export const resizeFloatingChat = ({
  start,
  edge,
  deltaX,
  deltaY,
  viewport,
}: ResizeFloatingChatParams): FloatingChatSize => {
  const resizesWidth = edge === "left" || edge === "top-left";
  const resizesHeight = edge === "top" || edge === "top-left";
  return {
    width: resizesWidth
      ? clamp(
          start.width - deltaX,
          MIN_FLOATING_CHAT_SIZE.width,
          viewport.width - FLOATING_CHAT_MARGIN * 2,
        )
      : start.width,
    height: resizesHeight
      ? clamp(
          start.height - deltaY,
          MIN_FLOATING_CHAT_SIZE.height,
          viewport.height - FLOATING_CHAT_MARGIN * 2,
        )
      : start.height,
  };
};
